<section class="terms-hero">
  <div class="container">
    <h1>Terms of Service</h1>
    <p class="subtitle">
      Please read these terms and conditions carefully before using our website and services.
    </p>
  </div>
</section>

<section class="terms-content">
  <div class="container">
    <div class="terms-grid">
      <div class="terms-document-card">
        <h2>1. Acceptance of Terms</h2>
        <p class="intro-text">
          By accessing and using the League City Yacht Sales website and services you agree to these
          Terms of Service. If you do not agree to these terms or would like to speak with someone
          directly please email us at
          <a href="mailto:contact@leaguecityyachtsales.com" class="contact-info"
            >contact@leaguecityyachtsales.com</a
          >.
        </p>

        <h2>2. Use of Services</h2>
        <p class="body-text">
          Our services include facilitating yacht sales, listing consultations, vessel viewings, and
          brokerage services. You agree to use these services only for lawful purposes and in a
          manner that does not infringe upon, restrict, or inhibit anyone else's use and enjoyment
          of the website.
        </p>

        <h2>3. Accuracy of Vessel Listings</h2>
        <p class="body-text">
          While we strive to maintain accurate and up-to-date listings, specifications, images, and
          pricing for all yachts, we do not warrant that any information is complete, current, or
          error-free. Vessel availability and details are subject to change.
        </p>

        <h2>4. Electronic & SMS Communications</h2>
        <p class="body-text">
          By submitting a contact form, email inquiry, or other messaging requests through this
          website, you consent to receive communication from our brokerage team. For SMS
          communications: you agree to receive automated or response text messages related to your
          initiated conversation. Message and data rates may apply. You can opt-out at any time by
          replying <strong>STOP</strong>, receive assistance by replying <strong>HELP</strong>, or
          opt back in by replying <strong>RESUME</strong>.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p class="body-text">
          League City Yacht Sales and its brokers shall not be liable for any direct, indirect,
          incidental, special, or consequential damages resulting from the use or inability to use
          our services, or from unauthorized access to your transmissions or data.
        </p>

        <h2>6. Governing Law</h2>
        <p class="body-text">
          These Terms of Service shall be governed by and construed in Galveston County in
          accordance with the laws of the State of Texas.
        </p>

        <h2>7. Contact Information</h2>
        <p class="body-text">
          For any questions, concerns, or requests regarding these terms, please contact our team
          at:
          <br /><br />
          <a href="mailto:contact@leaguecityyachtsales.com" class="contact-info"
            >contact@leaguecityyachtsales.com</a
          >
        </p>
      </div>
    </div>
  </div>
</section>
